import React from 'react';

const TimePickerControl = ({ id,
  field,
  value,
  onChange,
  onBlur,
  className,
  disabled,
  loading,
  props,
  'aria-invalid': ariaInvalid,
  'aria-describedby': ariaDescribedBy,
}) => {

  const inputId = id ?? "field_tp_" + field.FieldName;

  return (<>
    {field?.DisplayName && (
      <label htmlFor={inputId}>
        {field.DisplayName}
        {field.IsRequired ? " *" : ""}
      </label>
    )}
    <input id={inputId}
      placeholder={field.PlaceHolder}
      onBlur={(context) => onBlur(context, field)}
      value={value??''}
      className={className}
      disabled={disabled}
      type={'time'}
      onChange={(e) => onChange(e, field)}
      onKeyDown={(e) => e.preventDefault()}
      aria-invalid={ariaInvalid}
      aria-describedby={ariaDescribedBy}
      {...props} />
  </>
  );
}

export default TimePickerControl;